import { gql } from '@apollo/client';
import { BILLING_PLAN_DETAILS_FRAGMENT } from 'components/billing/gql/CompanyBillingDetailedQuery.graphql';
import LIMIT_SET_DETAILS_FRAGMENT from 'components/billing/gql/LimitSetDetailsFragment.graphql.js';

const COMPANY_STATUS_FRAGMENT = gql`
  fragment CompanyStatus on Company {
    active
    id
    databaseId
    cardOnFile
    trialEnd

    projectsCount
    usersCount

    plan {
      identifier
    }
    limitSet {
      ...LimitSetDetails
    }
  }
  ${LIMIT_SET_DETAILS_FRAGMENT}
`;

export const COMPANY_STATUS_QUERY = gql`
  query CompanyStatus {
    viewer {
      id
      company {
        ...CompanyStatus
      }
    }
  }
  ${COMPANY_STATUS_FRAGMENT}
`;

export const COMPANY_BILLING_QUERY = gql`
  query CompanyBilling {
    viewer {
      id
      company {
        ...CompanyStatus
      }
      billing {
        sampleEligible
        subscription {
          id
          emptySeats
        }
        availablePlans {
          ...BillingPlanDetails

          eligiblePlan
          messages {
            messageTitle
            content
            buttonText
            infoText
          }
        }
      }
    }
  }
  ${COMPANY_STATUS_FRAGMENT}
  ${BILLING_PLAN_DETAILS_FRAGMENT}
`;
